import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import useOnLoadPage from "../hooks/useOnLoadPage";
import RegistrationAdditionalInformationSection from "../sections/registration/RegistrationAdditionalInformationSection";
import RegistrationCompanyInformationSection from "../sections/registration/RegistrationCompanyInformationSection";
import RegistrationContactInformationSection from "../sections/registration/RegistrationContactInformationSection";
import RegistrationHeader from "../sections/registration/RegistrationHeader";
import { useCompany } from "../hooks/useCompany";
import { useState } from "react";
import Loader from "../components/common/Loader";
import LegalRequirements from "./LegalRequirementsPage";
import { Paths } from "../router/Paths";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";
import { toast } from "react-toastify";

export default function RegistrationPage() {
  const navigate = useNavigate();
  const { createCompany } = useCompany();

  const IsCompanyCompleted = useSelector(
    (state: RootState) => state.Companypending
  );
  const IsContanctCompleted = useSelector(
    (state: RootState) => state.ContanctPending
  );
  const IsAdditionalInformationCompleted = useSelector(
    (state: RootState) => state.additionalPending
  );

  const [activeTab, setActiveTab] = useState("companyDetails");
  const [loading, setLoading] = useState<boolean>(false);
  useOnLoadPage({ tabActive: "home" });

  const handleContinue = async () => {
    const IsContinueActive =
      IsCompanyCompleted &&
      IsContanctCompleted &&
      IsAdditionalInformationCompleted;

    if (IsContinueActive) {
      await createCompany({ setLoading });
      setActiveTab("legalRequirements");
    } else {
      const message = "Please Complete all the required fields.";
      message && toast["error"](message);
    }
  };
  return (
    <div className={Classname.container}>
      <Navbar />
      <div className="max-w-7xl">
        {/* Pass activeTab and setActiveTab as props */}
        <RegistrationHeader activeTab={activeTab} setActiveTab={setActiveTab} />

        {activeTab === "companyDetails" && (
          <div className={Classname.semiContainer}>
            <RegistrationCompanyInformationSection />
            <RegistrationContactInformationSection />
            <RegistrationAdditionalInformationSection />
          </div>
        )}

        {activeTab === "legalRequirements" && (
          <div className={Classname.semiContainer}>
            <LegalRequirements />
          </div>
        )}

        {activeTab === "companyDetails" && (
          <div
            className="flex justify-end pt-4 pb-10 px-6"
            onClick={handleContinue}
          >
            <Loader loading={loading} />
            {!loading && (
              <button className={Classname.continueButton}>Continue</button>
            )}
          </div>
        )}

        {activeTab === "legalRequirements" && (
          <div className="flex justify-end pt-4 pb-10 px-6">
            <button
              className={Classname.continueButton}
              onClick={() => navigate(Paths.welcome)}
            >
              Continue
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const Classname = {
  container: "w-full flex flex-col items-center mx-auto",
  semiContainer: "bg-gray-200 p-6 rounded-md gap-5 flex flex-col",
  continueButton: "ml-2 bg-blue-500 text-white px-4 py-2 rounded-lg",
};
